import { useEffect, useState } from 'react'
import styles from './Login.module.css'
import { useApolloClient } from '@apollo/client/react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client';
import { Alert, Col, Fade, Form, InputGroup, Row } from 'react-bootstrap';
import DefaultButton from '../../../components/buttons/default-button/DefaultButton';
import ModalBox from '../../../components/modal-box/ModalBox';

const LOGIN_QUERY = gql`
    query Auth($username: String!, $password: String!) {
        auth(username: $username, password: $password) {
            success
            errorMessage
        }
    }
`;

interface loginResult {
    auth: {
        success: boolean
        errorMessage?: string
    }
}

export default function Login() {
    const [ validated, setValidated ] = useState(false)
    const [ isError, setIsError ] = useState(false)
    const [ errorMessage, setErrorMessage ] = useState("")
    const [ username, setUsername ] = useState("")
    const [ password, setPassword ] = useState("")
    const client = useApolloClient()
    const navigate = useNavigate()

    // Check if already logged in
    useEffect(() => {
        const token = localStorage.getItem(process.env.REACT_APP_SESSION_TOKEN_NAME)
        if(token) {
            navigate('/admin/dashboard')
        }
    }, [ navigate ])


    const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
        e.preventDefault()

        // Reset error variables
        setIsError(false)
        setErrorMessage("")

        setValidated(true)

        if(username.length > 0 && password.length > 0) {
            try {
                const data = await client.query<loginResult>({
                    query: LOGIN_QUERY,
                    variables: { username, password },
                    fetchPolicy: 'no-cache'
                })

                if(!data || !data.data) {
                    setIsError(true)
                    setErrorMessage("Hiba a bejelentkezés közben")
                    return
                }

                const result = data.data.auth
                if(result.success) {
                    navigate('/admin/dashboard')
                }
                else {
                    const errorMessage = result.errorMessage ?? "Hiba a bejelentkezés közben"
                    setIsError(true)
                    setErrorMessage(errorMessage)
                }
            }
            catch {
                setIsError(true)
                setErrorMessage("Hiba a bejelentkezés közben")
            }
        }
        else {
            setIsError(true)
            setErrorMessage("Felhasználónév megadása kötelező<br />Jelszó megadása kötelező")
        }
    }

    return (
        <div className={ styles.container }>
            <ModalBox title="Bejelentkezés">
                <Form noValidate validated={ validated } onSubmit={ handleSubmit } >
                    <Row className='mb-3 justify-content-center'>
                        <Form.Group as={ Col } md="10" controlId="username">
                            <InputGroup hasValidation>
                                <Form.Control
                                    type="text"
                                    placeholder="Felhasználónév"
                                    required
                                    onChange={ e => setUsername(e.target.value) }
                                    className={ styles.input }
                                    autoFocus={ true }
                                />

                                <Form.Control.Feedback type="invalid">
                                    Felhasználónév megadása kötelező
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                    </Row>

                    <Row className='mb-3 justify-content-center'>
                        <Form.Group as={ Col } md="10" controlId="password">
                            <InputGroup hasValidation>
                                <Form.Control
                                    type="password"
                                    placeholder="Jelszó"
                                    required
                                    onChange={ e => setPassword(e.target.value) }
                                    className={ styles.input }
                                />

                                <Form.Control.Feedback className={ undefined } type="invalid">
                                    Jelszó megadása kötelező
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                    </Row>

                    <Row className='mb-3 justify-content-center'>
                        <Col md="10">
                            <Alert
                                show={ isError }
                                transition={ Fade }
                                variant='danger'
                                onClose={ () => setIsError(false) }
                                dismissible
                                className={ styles.loginAlert }
                            >
                                <b>
                                    <span dangerouslySetInnerHTML={{__html: errorMessage }}></span>
                                </b>
                            </Alert>
                        </Col>
                    </Row>

                    <Row className='mb-3 d-flex justify-content-center'>
                        <DefaultButton title='Bejelentkezés' />
                    </Row>
                </Form>
            </ModalBox>
        </div>
    )
}